export const achievements = [
  {
    id: 1,
    title: "Winner – Moloni Code Golf Battle",
    year: "2025",
    location: "Vila Real",
    category: "Competition",
    shortDescription: "Secured first place in this competition where the goal was to write the most efficient solution in JavaScript using the fewest bytes of code.",
    fullDescription: `Secured first place in this competition where the goal was to write the most efficient solution in JavaScript using the fewest bytes of code. This victory highlights not only my technical proficiency in JavaScript but also creativity and precision—qualities I bring to every project.`,
    skills: [
      "JavaScript",
      "Code Optimization",
      "Algorithm Design",
      "Problem Solving",
      "Competitive Programming"
    ],
    images: [
      "/achievements/moloni-1.jpg",
      "/achievements/moloni-2.jpg",
      "/achievements/moloni-3.jpg"
    ]
  },
  {
    id: 2,
    title: "Finalist – 929 Challenge",
    year: "2024",
    location: "Macau",
    category: "Business Competition",
    shortDescription: "Selected as a finalist in this prestigious business-ideas competition connecting China and Portuguese-speaking countries.",
    fullDescription: `Selected as a finalist in this prestigious business-ideas competition connecting China and Portuguese-speaking countries. Being among the finalists reflects my ability to develop solutions with international impact and think globally, focusing on themes such as sustainability and open innovation.`,
    skills: [
      "Business Strategy",
      "Innovation",
      "Sustainability",
      "International Markets",
      "Pitch Presentation"
    ],
    images: [
      "/achievements/929-macau-1.jpg",
      "/achievements/929-macau-2.jpg",
      "/achievements/929-macau-3.jpg"
    ]
  },
  {
    id: 3,
    title: "1st Place – INOV@UTAD Innovation Contest",
    year: "2024",
    location: "Vila Real",
    category: "Innovation Award",
    shortDescription: "Awarded first place in this contest hosted by the University of Trás-os-Montes and Alto Douro (UTAD) designed to promote early-stage business ideas.",
    fullDescription: `Awarded first place in this contest hosted by the University of Trás-os-Montes and Alto Douro (UTAD) designed to promote early-stage business ideas. This recognition underscores my entrepreneurial aptitudes and my skill in turning concepts into concrete award-winning proposals.`,
    skills: [
      "Entrepreneurship",
      "Business Development",
      "Innovation",
      "Concept Design",
      "Presentation"
    ],
    images: [
      "/achievements/inov-utad-1.jpg",
      "/achievements/inov-utad-2.jpg",
      "/achievements/inov-utad-3.jpg"
    ]
  },
  {
    id: 4,
    title: "1st Place – Hackathon Porto",
    year: "2024",
    location: "Porto",
    category: "Hackathon",
    shortDescription: "Achieved first place in this high-intensity collaborative development event showcasing my ability to adapt quickly and work effectively in team settings.",
    fullDescription: `Achieved first place in this high-intensity collaborative development event showcasing my ability to adapt quickly, work effectively in team settings and build prototypes under competitive conditions. This win reinforces my versatility in rapid innovation and problem-solving.`,
    skills: [
      "Rapid Prototyping",
      "Team Collaboration",
      "Full-Stack Development",
      "Time Management",
      "Problem Solving"
    ],
    images: [
      "/achievements/hackathon-porto-1.jpg",
      "/achievements/hackathon-porto-2.jpg",
      "/achievements/hackathon-porto-3.jpg"
    ]
  }
];
